import { Fragment, MutableRefObject, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { alertActions } from '../../_actions/alert.actions';
import animation_shield from '../../assets/01_Traverse_Paper_Shield.json';
import { Button, Dialog, MenuItem, TextField } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import animation_therm from '../../assets/02_Traverse_Thermometer.json';
import animation_clipboard from '../../assets/03_Traverse_Clipboard.json';
import animation_calendar from '../../assets/04_Traverse_Schedule.json';
import Lottie from 'lottie-react';
import RegistrationService from '../../services/registration.service';
import { User } from '../../proto/user';
import { IntakeRequest_TestOption } from '../../proto/auth';
import { Account, Account_AccountType } from '../../proto/account';


const numberOfEmployees = [
    { value: '1-50', label: '1-50' },
    { value: '51-100', label: '51-100' },
    { value: '101-500', label: '101-500' },
    { value: '501-1000', label: '501-1000' },
    { value: 'Over 1000', label: 'Over 1000' }
]

const numberOfTests = [
    { value: 'Unsure', label: 'Unsure' },
    { value: '1-50', label: '1-50' },
    { value: '51-100', label: '51-100' },
    { value: '101-500', label: '101-500' },
    { value: '501-1000', label: '501-1000' },
    { value: 'Over 1000', label: 'Over 1000' }
]

const States = [
    "AK",
    "AL",
    "AR",
    "AS",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "GU",
    "HI",
    "IA",
    "ID",
    "IL",
    "IN",
    "KS",
    "KY",
    "LA",
    "MA",
    "MD",
    "ME",
    "MI",
    "MN",
    "MO",
    "MS",
    "MT",
    "NC",
    "ND",
    "NE",
    "NH",
    "NJ",
    "NM",
    "NV",
    "NY",
    "OH",
    "OK",
    "OR",
    "PA",
    "PR",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VA",
    "VI",
    "VT",
    "WA",
    "WI",
    "WV",
    "WY"
]

type Props = {
    displaySuccessAlert: any,
    displayErrorAlert: any,
    history: any
}

enum RegistrationState {
    BASIC_INFO,
    TEST_OPTIONS,
    COMPLETE
}

enum FormField {
    COMPANY_NAME = 'Company Name',
    NUMBER_OF_EMPLOYEES = 'Number of Employees',
    ESTIMATED_WEEKLY_TESTS = 'Estimated Weekly Tests',
    HQ_ADDRESS = 'HQ Street Address',
    HQ_CITY = 'City',
    HQ_STATE = 'State',
    HQ_ZIP = 'Zip Code'
}

const BasicInfo = (props: Props) => {
    const history = useHistory();

    const user: MutableRefObject<User> = useRef(props.history?.location?.state?.user);
    const password: MutableRefObject<string> = useRef(props.history?.location?.state?.password);
    const referrerCode: MutableRefObject<string | undefined> = useRef(props.history.location.state.referrerCode);

    const [registrationState, setRegistrationState] = useState(RegistrationState.BASIC_INFO);
    const [testOptionState, setTestOptionState] = useState<IntakeRequest_TestOption | undefined>(undefined);
    const [diyDialogOpen, setDiyDialogOpen] = useState(false);
    const [nurseDialogOpen, setNurseDialogOpen] = useState(false);
    const [unsureDialogOpen, setUnsureDialogOpen] = useState(false);

    const [companyName, setCompanyName] = useState('');
    const [numEmployees, setNumEmployees] = useState('');
    const [estTests, setEstTests] = useState('');
    const [hqAddress, setHqAddress] = useState('');
    const [hqCity, setHqCity] = useState('');
    const [hqState, setHqState] = useState('');
    const [hqZip, setHqZip] = useState('');

    const [creating, setCreating] = useState(false);

    let [errors, setErrors] = useState<any>({});

    useEffect(() => {
        if (!user.current) {
            history.push('/');
        }
    }, [user.current])

    const updateForm = (name: string, value: any) => {
        switch (name) {
            case FormField.COMPANY_NAME:
                setCompanyName(value);
                break;
            case FormField.NUMBER_OF_EMPLOYEES:
                setNumEmployees(value);
                break;
            case FormField.ESTIMATED_WEEKLY_TESTS:
                setEstTests(value);
                break;
            case FormField.HQ_ADDRESS:
                setHqAddress(value);
                break;
            case FormField.HQ_CITY:
                setHqCity(value);
                break;
            case FormField.HQ_STATE:
                setHqState(value);
                break;
            case FormField.HQ_ZIP:
                setHqZip(value);
                break;
        }

        if (errors[name]) {
            validateField(errors, name, value);
        }
    }

    const validateForm = () => {
        let formErrors = JSON.parse(JSON.stringify(errors));

        formErrors = validateField(formErrors, FormField.COMPANY_NAME, companyName);
        formErrors = validateField(formErrors, FormField.NUMBER_OF_EMPLOYEES, numEmployees);
        formErrors = validateField(formErrors, FormField.ESTIMATED_WEEKLY_TESTS, estTests);
        formErrors = validateField(formErrors, FormField.HQ_ADDRESS, hqAddress);
        formErrors = validateField(formErrors, FormField.HQ_CITY, hqCity);
        formErrors = validateField(formErrors, FormField.HQ_STATE, hqState);
        formErrors = validateField(formErrors, FormField.HQ_ZIP, hqZip);

        setErrors(formErrors);

        return formErrors;
    }

    const validateField = (formErrors: any, name: string, value: any) => {
        const errorMessages = {
            required: `${name} is required`,
            malformed: `Invalid ${name}`,
        }

        const errorsCopy = JSON.parse(JSON.stringify(formErrors));

        switch (name) {
            case FormField.COMPANY_NAME:
                if (!value || value === '') {
                    errorsCopy[FormField.COMPANY_NAME] = errorMessages.required
                } else {
                    delete errorsCopy[FormField.COMPANY_NAME];
                }
                break;
            case FormField.NUMBER_OF_EMPLOYEES:
                if (!value || value === '') {
                    errorsCopy[FormField.NUMBER_OF_EMPLOYEES] = errorMessages.required
                } else {
                    delete errorsCopy[FormField.NUMBER_OF_EMPLOYEES];
                }
                break;
            case FormField.ESTIMATED_WEEKLY_TESTS:
                if (!value || value === '') {
                    errorsCopy[FormField.ESTIMATED_WEEKLY_TESTS] = errorMessages.required
                } else {
                    delete errorsCopy[FormField.ESTIMATED_WEEKLY_TESTS];
                }
                break;
            case FormField.HQ_ADDRESS:
                if (!value || value === '') {
                    errorsCopy[FormField.HQ_ADDRESS] = errorMessages.required
                } else {
                    delete errorsCopy[FormField.HQ_ADDRESS];
                }
                break;
            case FormField.HQ_CITY:
                if (!value || value === '') {
                    errorsCopy[FormField.HQ_CITY] = errorMessages.required
                } else {
                    delete errorsCopy[FormField.HQ_CITY];
                }
                break;
            case FormField.HQ_STATE:
                if (!value || value === '') {
                    errorsCopy[FormField.HQ_STATE] = errorMessages.required
                } else {
                    delete errorsCopy[FormField.HQ_STATE];
                }
                break;
            case FormField.HQ_ZIP:
                if (!value || value === '') {
                    errorsCopy[FormField.HQ_ZIP] = errorMessages.required
                } if (!value.match(/^[0-9]{5}(?:-[0-9]{4})?$/)) {
                    errorsCopy[FormField.HQ_ZIP] = errorMessages.malformed

                } else {
                    delete errorsCopy[FormField.HQ_ZIP];
                }
                break;
        }

        setErrors(errorsCopy);
        return errorsCopy;
    }

    const saveForm = () => {
        const formErrors = validateForm();

        if (Object.keys(formErrors).length > 0) {
            return;
        }

        setRegistrationState(RegistrationState.TEST_OPTIONS);
    }

    const completeRegistration = () => {
        const account: Account = {
            name: companyName,
            addressStreet: hqAddress,
            addressCity: hqCity,
            addressState: hqState,
            addressPostalCode: hqZip,
            roughEmployeeCount: numEmployees,
            estimatedTestRequirement: estTests,
            id: 0,
            created: new Date(),
            deleted: new Date(0),
            updated: new Date(),
            accountType: Account_AccountType.Standard,
            nurseEnabled: false,
            reportingTo: [],
            subcontractors: [],
            connectionURL: '',
            connectionInviteCode: '',
            connectionExpirationDate: new Date(),
            testsAvailable: 0
        }

        user.current.account = account;
        setCreating(true);

        RegistrationService.register(user.current, password.current, testOptionState!, referrerCode.current)
            .then((val) => {
                setCreating(false);
                history.push('/submitted', { user: user.current });
            }, (err) => {
                setCreating(false);
                props.displayErrorAlert(err);
            })

    }

    return <Fragment>
        {registrationState === RegistrationState.BASIC_INFO &&
            <div className="AppContent">
                <div className="FormContainer">
                    <div className="FormImage">
                        <Lottie style={{ height: 224 }} loop={false} animationData={animation_shield} />
                    </div>
                    <div>
                        <div className="FormTitle">
                            Let's learn more about your company
                        </div>
                        <div>
                            <div className="FormRow">
                                <TextField
                                    required
                                    value={companyName}
                                    onChange={(e) => { updateForm(FormField.COMPANY_NAME, e.target.value) }}
                                    onBlur={(e) => { validateField(errors, FormField.COMPANY_NAME, e.target.value) }}
                                    error={!!errors[FormField.COMPANY_NAME]}
                                    helperText={errors[FormField.COMPANY_NAME] ? errors[FormField.COMPANY_NAME] : ''}
                                    name={FormField.COMPANY_NAME}
                                    label={FormField.COMPANY_NAME}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </div>
                            <div className="FormRow">
                                <TextField
                                    required
                                    className="FormInputHalf"
                                    value={numEmployees}
                                    onChange={(e) => { updateForm(FormField.NUMBER_OF_EMPLOYEES, e.target.value) }}
                                    onBlur={(e) => { validateField(errors, FormField.NUMBER_OF_EMPLOYEES, e.target.value) }}
                                    error={!!errors[FormField.NUMBER_OF_EMPLOYEES]}
                                    helperText={errors[FormField.NUMBER_OF_EMPLOYEES] ? errors[FormField.NUMBER_OF_EMPLOYEES] : ''}
                                    name={FormField.NUMBER_OF_EMPLOYEES}
                                    label={FormField.NUMBER_OF_EMPLOYEES}
                                    variant="outlined"
                                    size="small"
                                    select
                                >
                                    {numberOfEmployees.map((numberOption) => (
                                        <MenuItem key={numberOption.value} value={numberOption.value}>
                                            {numberOption.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <TextField
                                    required
                                    className="FormInputHalf"
                                    value={estTests}
                                    onChange={(e) => { updateForm(FormField.ESTIMATED_WEEKLY_TESTS, e.target.value) }}
                                    onBlur={(e) => { validateField(errors, FormField.ESTIMATED_WEEKLY_TESTS, e.target.value) }}
                                    error={!!errors[FormField.ESTIMATED_WEEKLY_TESTS]}
                                    helperText={errors[FormField.ESTIMATED_WEEKLY_TESTS] ? errors[FormField.ESTIMATED_WEEKLY_TESTS] : ''}
                                    name={FormField.ESTIMATED_WEEKLY_TESTS}
                                    label={FormField.ESTIMATED_WEEKLY_TESTS}
                                    variant="outlined"
                                    size="small"
                                    select
                                >
                                    {numberOfTests.map((numberOption) => (
                                        <MenuItem key={numberOption.value} value={numberOption.value}>
                                            {numberOption.label}
                                        </MenuItem>
                                    ))}
                                </TextField>

                            </div>
                            <div className="FormRow">
                                <TextField
                                    required
                                    value={hqAddress}
                                    onChange={(e) => { updateForm(FormField.HQ_ADDRESS, e.target.value) }}
                                    onBlur={(e) => { validateField(errors, FormField.HQ_ADDRESS, e.target.value) }}
                                    error={!!errors[FormField.HQ_ADDRESS]}
                                    helperText={errors[FormField.HQ_ADDRESS] ? errors[FormField.HQ_ADDRESS] : ''}
                                    name={FormField.HQ_ADDRESS}
                                    label={FormField.HQ_ADDRESS}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="FormRow">
                                <TextField
                                    required
                                    className="FormInputHalf"
                                    value={hqCity}
                                    onChange={(e) => { updateForm(FormField.HQ_CITY, e.target.value) }}
                                    onBlur={(e) => { validateField(errors, FormField.HQ_CITY, e.target.value) }}
                                    error={!!errors[FormField.HQ_CITY]}
                                    helperText={errors[FormField.HQ_CITY] ? errors[FormField.HQ_CITY] : ''}
                                    name={FormField.HQ_CITY}
                                    label={FormField.HQ_CITY}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                                <TextField
                                    required
                                    className="FormInputHalf"
                                    value={hqState}
                                    onChange={(e) => { updateForm(FormField.HQ_STATE, e.target.value) }}
                                    onBlur={(e) => { validateField(errors, FormField.HQ_STATE, e.target.value) }}
                                    error={!!errors[FormField.HQ_STATE]}
                                    helperText={errors[FormField.HQ_STATE] ? errors[FormField.HQ_STATE] : ''}
                                    name={FormField.HQ_STATE}
                                    label={FormField.HQ_STATE}
                                    variant="outlined"
                                    size="small"
                                    select
                                    fullWidth
                                >
                                    {States.map((state) => (
                                        <MenuItem key={state} value={state}>
                                            {state}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <div className="FormRow">
                                <TextField
                                    required
                                    value={hqZip}
                                    onChange={(e) => { updateForm(FormField.HQ_ZIP, e.target.value) }}
                                    onBlur={(e) => { validateField(errors, FormField.HQ_ZIP, e.target.value) }}
                                    error={!!errors[FormField.HQ_ZIP]}
                                    helperText={errors[FormField.HQ_ZIP] ? errors[FormField.HQ_ZIP] : ''}
                                    name={FormField.HQ_ZIP}
                                    label={FormField.HQ_ZIP}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </div>
                        </div>

                        <div className="FormFooter">
                            <Button
                                onClick={() => { saveForm() }}
                                color="primary" variant="contained">Continue <ArrowForward /></Button>
                        </div>
                    </div>
                </div>
            </div>
        }

        {
            registrationState === RegistrationState.TEST_OPTIONS &&
            <div className="AppContentVertical">
                <div className="FormContainerVertical">
                    <div className="FormTitle">
                        How would you like to test?
                    </div>

                    <div className="FormImageOptionContainer">
                        <div className={"FormImageOption " + (testOptionState === IntakeRequest_TestOption.DIY ? "active" : "")}
                            onClick={() => { setTestOptionState(IntakeRequest_TestOption.DIY) }}>
                            <Lottie style={{ height: 174 }} loop={false} animationData={animation_therm} />
                            <div className="FormImageDetails">Do It Ourselves</div>
                            <div className="FormImageAction"
                                onClick={() => { setDiyDialogOpen(true) }}
                            >Learn More</div>
                        </div>
                        <div className={"FormImageOption " + (testOptionState === IntakeRequest_TestOption.NURSE ? "active" : "")}
                            onClick={() => { setTestOptionState(IntakeRequest_TestOption.NURSE) }}>
                            <Lottie style={{ height: 174 }} loop={false} animationData={animation_clipboard} />
                            <div className="FormImageDetails">Use a Traverse Nurse</div>
                            <div className="FormImageAction"
                                onClick={() => { setNurseDialogOpen(true) }}
                            >Learn More</div>
                        </div>
                        <div className={"FormImageOption " + (testOptionState === IntakeRequest_TestOption.OTHER ? "active" : "")}
                            onClick={() => { setTestOptionState(IntakeRequest_TestOption.OTHER) }}>
                            <Lottie style={{ height: 174 }} loop={false} animationData={animation_calendar} />
                            <div className="FormImageDetails">I'm Not Sure</div>
                            <div className="FormImageAction"
                                onClick={() => { setUnsureDialogOpen(true) }}
                            >Learn More</div>
                        </div>
                    </div>

                    <div className="FormFooter">
                        <Button
                            onClick={() => { setRegistrationState(RegistrationState.BASIC_INFO) }}
                            color="primary"
                        >
                            Go Back
                        </Button>
                        <Button
                            disabled={testOptionState === undefined || creating}
                            onClick={completeRegistration}
                            color="primary" variant="contained">
                            {(creating) && <span>Submitting...</span>}
                            {(!creating) && <span>Submit</span>}
                        </Button>
                    </div>

                    <Dialog
                        fullWidth
                        maxWidth="md"
                        className="FormDetailDialog"
                        open={diyDialogOpen}>
                        <div className="FormDetailDialogContent">
                            <div className="FormDetailDialogContentHeader">
                                Performing testing yourself
                            </div>
                            <div className="FormDetailDialogContentDetails">
                                If you chose to perform self-testing, we'll help get designated employees certified through a CDC approved training program to perform on-site tests. We will ship you enough tests so you are able to test every employee every week.
                            </div>
                            <div className="FormDetailDialogContentActions">
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={() => { setDiyDialogOpen(false) }}>OKAY, GOT IT</Button>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog
                        fullWidth
                        maxWidth="md"
                        className="FormDetailDialog"
                        open={nurseDialogOpen}>
                        <div className="FormDetailDialogContent">
                            <div className="FormDetailDialogContentHeader">
                                Leverage our national network of medical professionals
                            </div>
                            <div className="FormDetailDialogContentDetails">
                                Selecting from our nationwide database of nurse and medical professionals, our Traverse Nurse network makes on-stire staffing easy and efficient. Our qualified nurses ensure you're receiving quality testing from a trained medical professional at the desired testing locations and days you choose.                            </div>
                            <div className="FormDetailDialogContentActions">
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={() => { setNurseDialogOpen(false) }}>OKAY, GOT IT</Button>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog
                        fullWidth
                        maxWidth="md"
                        className="FormDetailDialog"
                        open={unsureDialogOpen}>
                        <div className="FormDetailDialogContent">
                            <div className="FormDetailDialogContentHeader">
                                Not Sure?
                            </div>
                            <div className="FormDetailDialogContentDetails">
                                If you are not sure which option is right for you and your company, you can consult one of our Traverse representatives. We would love the opportunity to learn about your company's needs and how we can help.
                            </div>
                            <div className="FormDetailDialogContentActions">
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={() => { setUnsureDialogOpen(false) }}>OKAY, GOT IT</Button>
                            </div>
                        </div>
                    </Dialog>
                </div>
            </div>

        }
    </Fragment>
}

const mapState = (state: any) => { return {} }

const actionCreators = {
    displayErrorAlert: alertActions.error,
    displaySuccessAlert: alertActions.success
};

const connectedApp = connect(mapState, actionCreators)(BasicInfo);

export { connectedApp as BasicInfo };